import React from 'react';
import { useTranslation, useLanguageQuery } from "next-export-i18n"


const SplashPage = () => {
    const { t } = useTranslation()
    const [query] = useLanguageQuery()
      return (
        <div className="hero w-full bg-lightBlue relative overflow-hidden h-screen">
          <div className="mt-20 xl:mt-2"></div>
          <div className="flex  max-w-7xl header mx-auto md:pb-14 px-4 md:p-10 mt-80 md:mt-48 xl:mt-20">
            <div className="self-auto md:self-center">
              <div className="grid  grid-cols-1 md:grid-cols-1 gap-14 relative">
                <div className="">
                  <div>
                    <h2 className="text-woundTextDark text-2xl md:text-2xl xl:text-4xl pb-3  md:pt-10 text-center md:text-left font-semibold   ">
                        Service Unavailable
                    </h2>
                    <p className=" text-lg xl:text-xl pb-4 md:mr-12 text-center md:text-left font-normal  ">
                    We regret to inform you that our intake services are currently unavailable. To assist you directly, please contact the North East Region Virtual Clinic below:
                    </p>
                    <p className=" text-lg xl:text-xl pb-4 md:mr-12 text-center md:text-left font-semibold  ">
                        Phone: 1-888-684-1999
                    </p>
                    <p className=" text-lg xl:text-xl pb-4 md:mr-12 text-center md:text-left font-normal  ">
                    We apologize for any inconvenience and appreciate your understanding. Please reach out to the clinic for any urgent matters or further assistance.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }

export default SplashPage;





